/*
 * SCSS → Tailwind token mapping (CreateNewIntakeFormInfo.scss deleted):
 *
 * .cnifi-field:
 *   display:flex / flex-direction:column / gap:6px / max-width:100%
 *   → flex flex-col gap-sp-0.75 w-full
 *   (gap: 6px = sp-0.75; max-width:100% = w-full)
 *
 * .cnifi-helper:
 *   font-size:13px / font-weight:400 / color:--text-medium / margin:0 / line-height:18px
 *   → text-size-2 font-normal text-text-light m-0 leading-[18px]
 *   (text-size-2 = 12px in DS; 13px has no exact token → text-[13px] used; leading-[18px] arbitrary)
 *
 * .cnifi-error:
 *   font-size:12px / color:--text-error
 *   → text-size-2 text-text-error
 *
 * .cnifi-footer / .cnifi-char-count: not used in this component's JSX — not mapped.
 *
 * Arbitrary values used: text-[13px] (13px helper text, no DS token), leading-[18px]
 */
import { memo } from 'react'
import type { ChangeEvent } from 'react'
import { Input, Label } from '@quickmd-llc/design-system'

type Props = {
  onSetIntakeFormNameValue: (value: string) => void
  newIntakeFormNameValue: string
  newIntakeFormNameError: boolean
  newIntakeFormNameLocalError: string
  isEdit?: boolean | undefined
}

const CreateNewIntakeFormInfo = memo(
  ({
    onSetIntakeFormNameValue,
    newIntakeFormNameValue,
    newIntakeFormNameError,
    newIntakeFormNameLocalError,
    isEdit,
  }: Props) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onSetIntakeFormNameValue(e.target.value)
    }

    return (
      <div className='flex w-full flex-col gap-sp-0.75'>
        <Label size='md'>Intake name</Label>
        {!isEdit && (
          <p className='m-0 text-[13px] font-normal leading-[18px] text-text-light'>
            Patients won't see the intake name. This is for your records.
          </p>
        )}
        <Input
          value={newIntakeFormNameValue}
          onChange={handleChange}
          placeholder={isEdit ? 'Enter intake form name' : 'e.g., Suboxone — New patient intake'}
          error={newIntakeFormNameError}
          disabled={isEdit ?? false}
          data-testid='pw_if-name-input'
        />
        {newIntakeFormNameError && newIntakeFormNameLocalError ?
          <span className='text-size-2 text-text-error'>{newIntakeFormNameLocalError}</span>
        : null}
      </div>
    )
  },
)

export { CreateNewIntakeFormInfo }
